import { render, staticRenderFns } from "./AxTempGeneralHistoryDialog.vue?vue&type=template&id=ed986172&scoped=true"
import script from "./AxTempGeneralHistoryDialog.vue?vue&type=script&lang=ts"
export * from "./AxTempGeneralHistoryDialog.vue?vue&type=script&lang=ts"
import style0 from "./AxTempGeneralHistoryDialog.vue?vue&type=style&index=0&id=ed986172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed986172",
  null
  
)

export default component.exports